module.exports = "<div class=\"DAG-Label\">\r\n    <div [class]=\"getClass()\" (click)=\"onClick()\">\r\n        {{text}}\r\n    </div>\r\n</div>\r\n"